(function () {
  let blockAppearance = false;

  const submitBtns = document.querySelector(".product-form__item--submit");
  const footer = document.querySelector('.footer__bottom');
  const stickyBtnsWrapper = document.querySelector(".sticky-buttons");
  const cartContainer = document.querySelector(".quick-cart__container");
  const personalizationField = document.querySelector('#personalization_field_name[required]');
  const stickyPersonalizationField = document.querySelector('.sticky-buttons #sticky_btns_personalization_field_name');
  const stickyProductForm = document.querySelector('.sticky-buttons form.product-form');
  const productAddToCart = document.querySelector('.product form.product-form .product-form__cart-submit');

  if (personalizationField && stickyPersonalizationField && productAddToCart && stickyProductForm) {
    personalizationField.addEventListener('change', (e) => {
      stickyPersonalizationField.value = e.currentTarget.value;
    });

    if (!stickyPersonalizationField.value.trim()) {
      stickyProductForm.addEventListener('submit', (e) => {
        e.preventDefault();

        productAddToCart.click();

        if (!stickyPersonalizationField.value.trim()) {
          personalizationField.closest('.product__meta')?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    }
  }

  const options = {
    rootMargin: "0px",
    threshold: 1,
  };

  const callback = function (entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if (entry.target.classList.contains('quick-cart__container')) {
          blockAppearance = true;
        }

        if (!blockAppearance) {
          stickyBtnsWrapper.classList.add('sticky-buttons--hidden');
        }
      } else {
        if (!blockAppearance) {
          stickyBtnsWrapper.classList.remove('sticky-buttons--hidden');
        }

        if (entry.target.classList.contains('quick-cart__container')) {
          blockAppearance = false;
        }
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);

  observer.observe(submitBtns);
  observer.observe(footer);
  observer.observe(cartContainer);
})();
